import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";
import { saveAs } from 'file-saver';
const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-worlds',
  templateUrl: './worlds.component.html',
  styleUrls: ['./worlds.component.css']
})
export class WorldsComponent extends BaseComponent implements OnInit {
  @ViewChild('canvas', { static: true })
  canvas: ElementRef<HTMLCanvasElement>
  ctx: any
  database = inject(Database);
  worldsRef: any;
  worlds: any; //downloaded worlds from database
  worldskeys: any = [] //keys of properties of worlds {id:0,name: "demo"}
  worldkey = 0 //index for select
  world: any = null //selected world
  worldname: any = "" //name of selected world
  surveys: any = []
  surveylist: any = [] //simple list of index and name of surveys for select boxes
  surveyOptions: any = []
  selectedSurveyKey = 0

  lessonplans: any = []
  selectedLessonplanid = 0
  lessonplansteps: any = []
  selectedLPStepid = 0
  lessonplanstepoptions: any = []

  seqNo = "10"
  skybox: any = {}
  walls: any = {}
  ground: any = {}
  components: any = []
  component: any = {} //component to edit
  rooms: any = []
  interactivities: any = []
  interactivitySer = ""
  interactivityIndex = 0
  interactivity: any = {}
  newWorldName = ""
  showModal = false

  sortArray: any = []
  showPlot = false

  showSkyboxInfo = false
  showComponentInfo = false
  showGroundInfo = false
  showVideoInfo = false
  showFenceInfo = false
  showSpecialInfo = false
  showSignInfo = false
  showHeaderinfo = false
  showTabs = false // prevent error fo null reference by only showing the fields once a work is loaded
  isAuthenticatedWithFirebase = false

  //different modals for different interactivity types
  showGeneralInteractivity = false
  showInteractivityTypeModal = false
  showInterctivityTypeSurvey = false
  showRoomComponent = false
  showVehicleMovementComponent = false
  showRepeaterComponent = false
  showtriggerSensorComponent = false
  showTriggerSensorDecsription = false
  roomcomponent: any = {}
  roomcomponentIndex = -1
  triggergroups: any = []
  
  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }
  async getData() {
    this.loader.show()
    this.worldsRef = ref(this.database, 'worlds');
    const snapshot = await get(this.worldsRef);
    if (snapshot.exists()) {
      // const val = snapshot.val();
      this.worlds = snapshot.val();

      this.worldskeys = this.getKeys(this.worlds)
      // this.worlds = this.collectionToArray2(val)
      // this.worldskeys = this.getKeys(this.worlds)
    }

    this.loader.hide()
  }


  async signOut() {
    try {
      await getAuth().signOut()
      this.isAuthenticatedWithFirebase = false
    } catch (error) {
      console.log(error)
    }
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  async selectWorld() {
    this.worldname = this.worldskeys[this.worldkey].name
    this.world = this.worlds[this.worldname]
    this.world.isIndoorLighting = this.world.isIndoorLighting == null ? false : this.world.isIndoorLighting

    this.components = this.world.components
    if (this.components != null) {
      this.components.forEach((component: any, index: number) => {
        if (component['rotX'] == null) component['rotX'] = 0
        if (component['rotY'] == null) component['rotY'] = 0
        if (component['rotZ'] == null) component['rotZ'] = 0
        if (component['checkCollisions'] == null) component['checkCollisions'] = true
        component['id'] = index
      })
    }

    this.walls = this.world.walls
    this.ground = this.world.ground
    this.interactivities = this.world.interactivities
    // sort interactivities by the property "type" using the array sort function
    // and put iut back into the interactivy array
    if (this.interactivities != null) {
      if (!Array.isArray(this.interactivities)){
        this.interactivities = this.convertObjectToArray(this.interactivities) 
      }
      this.interactivities.sort((a: any, b: any) => {
        if (a.type < b.type) return -1
        if (a.type > b.type) return 1
        return 0
      })
    }


    if (this.ground.terrain == null) this.ground.terrain = ""
    this.skybox = this.world.skybox
    this.showTabs = true

    const lessonplanRef = ref(this.database, 'lessonplans');
    const lessonplanSnapshot = await get(lessonplanRef);
    if (lessonplanSnapshot.exists()) {
      const lessonplanstp = lessonplanSnapshot.val();
      this.lessonplans = []
      let counter = 0; // Initialize counter
      for (const key in lessonplanstp) {
        if (Object.hasOwnProperty.call(lessonplanstp, key)) {
          this.lessonplans.push({ id: counter, name: key })
          counter++; // Increment counter
        }
      }
    }
    this.rooms = this.world.rooms

    //this.plotObjects();
  }

  convertObjectToArray(obj: any) {
    let ret = []
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const element = obj[key];
        ret.push(element)
      }
    }
    return ret
  }
  editComponent(c: any) {
    this.component = c
    this.showModal = true
  }
  nameHasChanged() {
    //this.component.file = this.component.name + ".glb"
  }

  addComponent() {
    this.component = {
      name: "newName",
      file: "newFile",
      posX: 0,
      posY: 0,
      posZ: 0,
      rotX: 0,
      rotY: 0,
      rotZ: 0,
      scale: 1,
      checkCollisions: true
    }
    if (this.components == null) {
      this.components = []
      this.world.components = this.components
    }
    this.components.push(this.component)
    this.showModal = true
  }

  async deleteComponent(c: any) {
    let index = -1
    this.components.forEach((obj: any, ind: number) => {
      if (obj != null) {
        if (c.name == obj.name) index = ind
      }
    })
    //const index = this.components.findIndex((obj: any) => obj.name === c.name);

    // Remove the object if it's found
    if (index !== -1) {
      this.components.splice(index, 1);
      //await this.updateWorld()
    }
  }
  async updateWorld() {
    //this.worlds.demo.components[0].posY=3
    this.showModal = false
    await set(this.worldsRef, this.worlds);
    //this.plotObjects()
  }
  // equivalent to addClone create addSensor with the fields name, units,min_distance, max_distance, max_value
  addSensor() {
    if (this.component['sensors'] == null) this.component['sensors'] = []
    const sensor = {
      name: "newSensor",
      units: "m",
      min_distance: 0,
      max_distance: 10,
      max_value: 100
    }
    this.component['sensors'].push(sensor)
  }

  deleteSensor(sensor: any) {

  }
  addClone() {
    if (this.component['clones'] == null) this.component['clones'] = []
    const clone = {
      posX: 0,
      posY: 0,
      posZ: 0,
      rotX: 0,
      rotY: 0,
      rotZ: 0
    }
    this.component['clones'].push(clone)
  }
  deleteClone(clone: any, i: number) {
    this.component['clones'].splice(i, 1);
  }
  plotObjects() {
    // Clear the canvas
    this.canvas.nativeElement.width = this.canvas.nativeElement.width == 100 ? 700 : 100
    this.canvas.nativeElement.height = this.canvas.nativeElement.height == 100 ? 700 : 100
    this.ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);

    // Loop through your objects to plot them
    if (this.components != null) {
      this.components.forEach((obj: any) => {
        const { x, y } = this.mapToCanvasCoord(obj.posX, obj.posZ, 55, 55);

        // Draw a circle at the object's position
        this.ctx.beginPath();
        this.ctx.arc(x, y, 5, 0, Math.PI * 2);
        this.ctx.fillStyle = "green"
        this.ctx.fill();
        this.ctx.fillStyle = "blue"
        // Add the object's name next to the circle
        this.ctx.fillText(obj.name, x + 10, y - 2 + Math.random() * 20);
      });

    }
  }
  mapToCanvasCoord(x: number, y: number, width: number, height: number) {
    const canvas = this.canvas.nativeElement;
    const mappedX = (x + width / 2) * (canvas.width / width);
    const mappedY = (height / 2 - y) * (canvas.height / height);
    return { x: mappedX, y: mappedY };
  }
  async addWorld() {
    let dupObj = this.worldskeys.find((k: any) => k.name == this.newWorldName)
    if (dupObj == null) {
      this.selectWorld()
      const copiedObject = JSON.parse(JSON.stringify(this.world))
      this.worlds[this.newWorldName] = copiedObject
      await this.updateWorld()
    } else {
      this.alert.danger("Name of World must be unique")
    }
  }
  createCloneFence(component: any) {
    component.cloneFence = { path: "sss", width: 2 }
  }
  removeCloneFence(component: any) {
    delete component.cloneFence
  }
  createDoSmoke(component: any) {
    component.doSmoke = { scaling: 1 }
  }
  removeDoSMoke(component: any) {
    delete component.doSmoke
  }
  createSign(component: any) {
    component.sign = {
      path: "sss",
      posX: 0, posY: 0, posZ: 0,
      rotX: 0, rotY: 0, rotZ: 0,
      scalingX: 0.5, scalingY: 0.5, scalingZ: 0.5
    }
  }
  removeSign(component: any) {
    delete component.sign
  }

  createVideo(component: any) {
    component.video = {
      path: "",
      posX: 0, posY: 0, posZ: 0,
      rotX: 0, rotY: 0, rotZ: 0,
      width: 100, height: 100
    }
  }
  removeVideo(component: any) {
    delete component.video
  }
  getSpecial(component: any) {
    let ret = ""
    if (component.cloneFence != null) ret = "has fence clones"
    if (component.video != null) ret = "has video"
    if (component.doSmoke != null) ret = "do Smoke"
    return ret
  }
  async updateInteractivity() {
    this.interactivities[this.interactivityIndex] = JSON.parse(this.interactivitySer)
    await this.updateWorld()
  }

  async openModalInter(i: number) {
    this.interactivityIndex = i
    this.interactivity = this.interactivities[i]
    this.interactivitySer = JSON.stringify(this.interactivities[i])
    let type = this.interactivities[i].type

    if (type == "survey") {
      const surveysRef = ref(this.database, 'surveys');
      const snapshot = await get(surveysRef);
      if (snapshot.exists()) {
        this.surveys = snapshot.val();
        let counter = 0; // Initialize counter
        this.surveylist = []
        for (const key in this.surveys) {
          if (Object.hasOwnProperty.call(this.surveys, key)) {
            this.surveylist.push({ id: counter, name: key })
            if (key == this.interactivity.surveyname) this.selectedSurveyKey = counter
            counter++; // Increment counter
          }
        }
      }

      const lessonplanname = this.lessonplans[this.selectedLessonplanid].name
      const lpstepsRef = ref(this.database, 'lessonplans/' + lessonplanname);
      const lpstepssnapshot = await get(lpstepsRef);
      if (lpstepssnapshot.exists()) {
        this.lessonplansteps = lpstepssnapshot.val();
        this.lessonplanstepoptions = []
        this.lessonplansteps.forEach((step: any, index: number) => {
          this.lessonplanstepoptions.push({ id: index, name: step.name })
          if (step.name == this.interactivity.lessonplanstepid) this.selectedLPStepid = index
        })
      }

      this.showInterctivityTypeSurvey = true
      return
    }
    if (type == "modal") {
      this.showInteractivityTypeModal = true
      return
    }
    if (type == "vehiclemovement") {
      this.showVehicleMovementComponent = true
      return
    }
    if (type == "repeater") {
      this.showRepeaterComponent = true
      return
    }
    if (type == "triggersensor") {
      this.showtriggerSensorComponent = true
      return
    }
    this.showGeneralInteractivity = true

  }
  addInteractivity() {
    if (this.interactivities == null) {
      this.interactivities = []
      this.world.interactivities = this.interactivities
    }
    this.interactivities.push({ class: "video", "glb-file": "none" })
    //find the index of this new interactivity
    this.interactivityIndex = this.interactivities.length - 1
    this.interactivitySer = JSON.stringify(this.interactivities[this.interactivityIndex])
    this.showInteractivityTypeModal = true
  }
  async deleteInteractivity(i: number) {
    this.interactivities.splice(i, 1);
    await this.updateWorld()
  }
  updateSensorInteractivity() {
    //this.interactivities[this.interactivityIndex] = JSON.parse(this.interactivitySer)
  }

  async addSurvey() {

    const surveysRef = ref(this.database, 'surveys');
    const snapshot = await get(surveysRef);
    if (snapshot.exists()) {
      this.surveys = snapshot.val();
    }

    this.surveyOptions = []
    let keys = Object.keys(this.surveys);
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i]
      let option = { id: i, name: key }
      this.surveyOptions.push(option)
    }
    this.showInterctivityTypeSurvey = true
  }
  updateSurveyInteractivity() {
    // <sa-select [(Id)]="selectedSurveyKey" [title]="'Survey to be used'" [options]="surveylist"></sa-select>
    // <sa-select [(Id)]="selectedLPStepid" [title]="'Lesson Plan Step'" [options]="lessonplansteps"></sa-select>
    // <sa-input-text [(text)]="interactivity.name" [title]="'unique name of this interactivity (can be anything)'"></sa-input-text>
    // <sa-input-text [(text)]="interactivity.buttontext" [title]="'Text on button in lesson plan'"></sa-input-text>
    // <sa-input-number [(text)]="seqNo" [title]="'SeqNo (not really needed anymore)' "></sa-input-number>
    // {"type": "survey", "name": "Flammability","lessonplanstepid": "LP-Flammability", "surveyname":"mercury","seqNo": 20,  }

    const type = "survey"
    const surveyname = this.surveylist[this.selectedSurveyKey].name
    const lessonplanstepid = this.lessonplanstepoptions[this.selectedLPStepid].name
    let seqNo = parseInt(this.seqNo)
    let interactiviy = {
      "type": 'survey', "surveyname": surveyname, "lessonplanstepid": lessonplanstepid,
      "name": this.interactivity.name, "buttontext": this.interactivity.buttontext, "seqNo": seqNo
    }
    this.interactivities[this.interactivityIndex] = interactiviy
    this.updateWorld()
    this.showInterctivityTypeSurvey = false
  }

  async moveInteractivityUp(i: number) {
    this.interactivities = this.moveElementHigher(this.interactivities, i)
    this.world.interactivities = this.interactivities
    await this.updateWorld()
  }

  moveElementHigher<T>(array: T[], index: number): T[] {
    // Clone the array to avoid mutating the original array
    let newArray = [...array];

    // Check if the index is valid and not the first element
    if (index > 0 && index < newArray.length) {
      // Swap the element with the one before it
      [newArray[index], newArray[index - 1]] = [newArray[index - 1], newArray[index]];
    }

    return newArray;
  }
  deleteRoomComponent(i: number) {
    this.rooms.splice(i, 1)
    this.updateWorld()
  }

  async updateRoomComponent() {
    if (this.roomcomponentIndex == -1) {
      this.rooms.push(this.roomcomponent)
    } else{
      this.rooms[this.roomcomponentIndex] = this.roomcomponent
    } 
    await this.updateWorld()
  }
  copyRoomComponent(i:number){
    this.roomcomponent = JSON.parse(JSON.stringify(this.rooms[i]))
    this.roomcomponentIndex = -1
    this.showRoomComponent = true
  }
  openModalRoomComponent(i: number) {
    this.roomcomponentIndex = i
    if (i == -1) {
      this.roomcomponent = {
        seqNo: 10,
        ref: "",
        name: "newName",
        glb: "newFile.glb",
        type: "Outer",
        active: "x",
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      }
    } else {
      this.roomcomponent = this.rooms[i]
    }
    this.showRoomComponent = true
  }
  async deleteVehicle(i: number) {
    this.interactivity.vehicles.splice(i,1)
    await this.updateWorld()
  }
  async updateVehicleMovementComponent() {
    await this.updateWorld()
    this.showVehicleMovementComponent = false
  }
  async createVehicleMovement(){
    let vm = {meshname:"newMesh",speed:30,xStart:0,yStart:0,zStart:0,xEnd:0,yEnd:0,zEnd:0}
    this.interactivity.vehicles.push(vm)
    await this.updateWorld()
  }
  async updateRepeatComponent() {
    await this.updateWorld()
    this.showRepeaterComponent = false
  }
  async updateTriggerSensorComponent(){
    await this.updateWorld()
    this.showtriggerSensorComponent = false
  }
  async deleteTarget(i:number){
    this.interactivity.targets.splice(i,1)
    await this.updateWorld()
  }
  async addTriggerSensorTarget(){
    if (this.interactivity.targets == null) this.interactivity.targets = []
    this.interactivity.targets.push({meshname:"newName",isActive:"newValue","reading":0})
  }
  downloadAsCSV(data: any) {
    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "componentvalues.csv");
  }
}
